/* @jsx h */
import { defineComponent, h, computed } from "vue";
import { calculateCartSubtotal } from "@lemmonhq/orders";
import { useMenu } from "@app/vue/providers/index";

import { GroupMember } from "../../../providers/Menu/realtime/index";
import { useLocalization } from "@lemmonhq/uikit";

export interface PendingOrderCardProps {
  member: GroupMember;
  members: GroupMember[];
  characterName?: string | null;
}

export const PendingOrderCard = defineComponent<PendingOrderCardProps>({
  name: "PendingOrderCard",
  props: ["member", "members", "characterName"],
  setup(props) {
    const { shop } = useMenu();
    const { t } = useLocalization();
    const memberName = computed(() => {
      return (
        props.characterName ||
        props.member.clientName ||
        t("customer.checkout_status.guest")
      );
    });
    const memberInitial = computed(() => {
      return memberName.value.split(" ")[0];
    });

    return () => (
      <div class="rounded bg-base-200 shadow-lg hover:shadow-xl border rounded-lg ">
        <div class={`p-3 lg:p-4`}>
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-3">
              <div class="avatar placeholder hidden">
                <div class="bg-warning text-warning-content rounded-full shadow-md w-10 h-10 flex justify-center items-center rounded-full">
                  <span class="text-lg font-bold">{memberInitial.value}</span>
                </div>
              </div>
              <div>
                <div class={`font-bold `}>{memberName.value}</div>
                <div class="flex gap-2">
                  <div class="badge badge-warning badge-sm mb-1 shadow-sm">
                    {t("customer.checkout_status.ordering")}
                  </div>
                </div>
                <div class="text-xs text-base-content/60 font-mono hidden">
                  {props.member.clientId.slice(0, 8)}...
                </div>
              </div>
            </div>
            <div class="text-right">
              <div class={`font-bold`}>
                {t(
                  props.member.cart.items.length === 1
                    ? "customer.checkout_status.item_count_one"
                    : "customer.checkout_status.item_count_many",
                  [props.member.cart.items.length],
                )}
              </div>
              <div class="text-xs text-base-content/60">
                {shop.value.currency}{" "}
                {calculateCartSubtotal(props.member.cart).toFixed(2)}
              </div>
            </div>
          </div>

          {props.member.cart.items.length > 0 && (
            <div class="mt-2 pt-3 border-t border-success/20">
              <div class="text-sm text-accent font-semibold mb-2 flex items-center gap-1">
                <span class="material-symbols-outlined text-xs">
                  shopping_cart
                </span>
                {t("customer.checkout_status.items")}
              </div>
              <div class="flex flex-wrap gap-1">
                {props.member.cart.items.map((item, itemIndex) => (
                  <span key={itemIndex} class="text-sm">
                    {item.quantity}× {item.name}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  },
});
